export * from './icon';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /home/backend/KreditCentr/WebLombard/client/~/@angular/material/icon/index.js
// module id = ../../../material/icon/index.js
// module chunks = 3